'use client'

import * as apiSvc from "api/components/cmmn/CmmnApiCallService"
import { useEffect, useState } from 'react';
import { Form } from "react-bootstrap";
import styled from "styled-components";

const ErrorMsg = styled.p`
    margin-left: 1rem;
    font-size: 0.9rem;
    color: #ef2929;
`;
export default function CmmnCdSelectBox({
    cmmnCdId,
    defaultOptTxt,
    defaultVal,
    tagName,
    onSelectChange,
    className,
    readonly,
    disabled,
    errorTxt,
    filterCmmnCd,
}) {

    const [showOptions, setShowOptions] = useState(false);
    const [selectedVal, setSelectedVal] = useState(defaultVal || '');
    const [cmmnCdList, setCmmnCdList] = useState([]);

    const HandleShowOption = () => {
        //readonly 가 아닐때만 작동
        if (readonly !== true) {
            setShowOptions((current) => !current);
        }
    };
    const HandleMouseLeave = () => {
        setShowOptions(false);
    };

    useEffect(() => {
        apiSvc.GetCmmnCdList({ cmmnCdId })
            .then(res => {

                const filteredRes = filterCmmnCd && filterCmmnCd.length > 0
                    ? res.filter(data => !filterCmmnCd.includes(data.cmmnCd))
                    : res;

                // console.log(res);
                setCmmnCdList(filteredRes);
                if (defaultVal === 0 || defaultVal === '') {
                    setSelectedVal('');
                } else {
                    const selectedCd = res.find(data => data.cmmnCd == defaultVal);
                    if (selectedCd) {
                        setSelectedVal(selectedCd.cmmnCd);
                    }
                }
            })
            .catch(error => {
                console.log(error);
            });
    }, [defaultVal, cmmnCdId, filterCmmnCd]);

    const handleSelectChange = (e) => {
        const selectedVal = e.target.value;
        // console.log(selectedVal);
        setSelectedVal(selectedVal);
        const event = { target: { name: tagName, value: selectedVal } };
        onSelectChange(event);
    };


    return (
        <>
            <Form.Select
                name={tagName}
                value={selectedVal}
                onChange={handleSelectChange}
                disabled={disabled}
                className={className}
            >
                <option value="">{defaultOptTxt}</option>
                {cmmnCdList.map((cmmn) => (
                    <option key={cmmn.cmmnCd} value={cmmn.cmmnCd}>
                        {cmmn.cmmnCdNm}
                    </option>
                ))}
            </Form.Select>
            {errorTxt && <ErrorMsg>{errorTxt}</ErrorMsg>}
        </>
    );
}